// useHasPermission — single permission check honoring `*` and prefix wildcards.
// Plan 23 PR0a promotes DP shell's `buildPermissions` helper to this hook.
import { holdsOrgPlanePermission } from '@zion/sdk-contracts';
import { usePermissionSnapshot } from './PermissionContext.js';
/**
 * Returns true iff the current principal holds `permission`. When
 * `resourceId` is supplied, additionally consults the snapshot's resource
 * grants — the principal passes if either:
 *   - they hold `permission` site-wide / org-wide (with wildcards), or
 *   - their token carries `permission` as an app-permission tuple key
 *     (`appPermissionKeys`, #2883; exact match, never a reserved org key), or
 *   - they have a matching `(permission, resourceId)` resource grant.
 */
export function useHasPermission(permission, resourceId) {
    const snap = usePermissionSnapshot();
    const granted = [
        ...snap.siteRoles,
        ...snap.sitePermissions,
        ...snap.orgRoles,
        ...snap.orgPermissions,
    ];
    if (holdsOrgPlanePermission(granted, snap.appPermissionKeys, permission))
        return true;
    if (resourceId !== undefined) {
        return snap.resourceGrants.some((g) => g.permission === permission && g.resourceId === resourceId);
    }
    return false;
}
//# sourceMappingURL=useHasPermission.js.map